import styled from 'styled-components';

const UnsupportedText = styled.span`
  font-family: 'Avenir', 'Arial', sans-serif;
  font-weight: 900;
  letter-spacing: 1px;
  font-size: 13px;
  text-align: center;
  line-height: 22px;
`;

export default UnsupportedText;
